"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_COLOR_INPUT_STRING_LENGTH = void 0;
// this is used to prevent regex matcher from evaluating a long string that can be assumed to be incorrect
// currently not applied to filter
exports.MAX_COLOR_INPUT_STRING_LENGTH = 25;
